import { ApolloProvider } from '@apollo/client/react';
import { loadSentry } from '@opendoor/observability/sentry';
import { loadGoogleTagManager } from '@opendoor/shared-fe/googleTagManager';
import { loadSegment } from '@opendoor/shared-fe/segment';
import { createRoot } from 'react-dom/client';

import App from './App';
import { apolloClient } from './config/apolloClients';
import { SessionContext, Sessions } from './config/context';
import { PartnerContextProvider } from './config/PartnerContext';

import './styles/index.css';

// https://sentry.io/settings/opendoor/projects/partnership-dashboard-fe/keys/
const RAVEN_URL = 'https://bc50f25b43e24d70abc6cf650d88de80@o117144.ingest.sentry.io/1382664';
loadSentry(RAVEN_URL);

loadGoogleTagManager();
loadSegment();
const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ApolloProvider client={apolloClient}>
    <SessionContext.Provider value={Sessions}>
      <PartnerContextProvider>
        <App />
      </PartnerContextProvider>
    </SessionContext.Provider>
  </ApolloProvider>,
);
